import { estimateHeight, type BuildingFeature, type LngLat } from './shadows'

type OverpassElement = {
  type: string
  id: number
  tags?: Record<string, string>
  geometry?: { lat: number; lon: number }[]
}

export async function fetchBuildingsAround(
  lat: number,
  lng: number,
  radiusM = 250,
  signal?: AbortSignal,
): Promise<BuildingFeature[]> {
  const res = await fetch(
    `/api/buildings?lat=${encodeURIComponent(lat)}&lng=${encodeURIComponent(lng)}&radius=${radiusM}`,
    { signal },
  )
  if (!res.ok) throw new Error(`Buildings fetch failed: ${res.status}`)
  const data = (await res.json()) as { elements: OverpassElement[] }
  return parseOverpass(data.elements || [])
}

function parseOverpass(elements: OverpassElement[]): BuildingFeature[] {
  const out: BuildingFeature[] = []
  for (const el of elements) {
    if (!el.geometry || el.geometry.length < 3) continue
    const ring: LngLat[] = el.geometry.map((g) => [g.lon, g.lat])
    if (
      ring[0][0] !== ring[ring.length - 1][0] ||
      ring[0][1] !== ring[ring.length - 1][1]
    ) {
      ring.push(ring[0])
    }
    const tags = el.tags || {}
    const levels = tags['building:levels']
      ? parseFloat(tags['building:levels'])
      : null
    out.push({
      id: `${el.type}/${el.id}`,
      height: estimateHeight(tags),
      levels: levels && !Number.isNaN(levels) ? levels : null,
      ring,
    })
  }
  return out
}
